import { DateTime } from 'luxon';

declare global {
  interface Date {
    readonly min: Date;
    readonly max: Date;
    readonly start: Date;
    readonly end: Date;
    readonly toDateOnly: string;
    readonly toLocalISOString: string;
    readonly toUTCISOString: string;

    addDays(days: number): Date;
  }
}

if (!Object.prototype.hasOwnProperty.call(Date.prototype, 'min')) {
  Object.defineProperty(Date.prototype, 'min', {
    get: function () {
      return new Date(1900, 0, 1, 0, 0, 0, 0);
    },
  });
}

if (!Object.prototype.hasOwnProperty.call(Date.prototype, 'max')) {
  Object.defineProperty(Date.prototype, 'max', {
    get: function () {
      return new Date(2100, 0, 0, 23, 59, 59, 999);
    },
  });
}

if (!Object.prototype.hasOwnProperty.call(Date.prototype, 'start')) {
  Object.defineProperty(Date.prototype, 'start', {
    get: function () {
      return new Date(this.setHours(0, 0, 0, 0));
    },
  });
}

if (!Object.prototype.hasOwnProperty.call(Date.prototype, 'end')) {
  Object.defineProperty(Date.prototype, 'end', {
    get: function () {
      return new Date(this.setHours(23, 59, 59, 999));
    },
  });
}

if (!Date.prototype.addDays) {
  Date.prototype.addDays = function (days: number): Date {
    this.setDate(this.getDate() + days);
    return this;
  };
}

if (!Object.prototype.hasOwnProperty.call(Date.prototype, 'toDateOnly')) {
  Object.defineProperty(Date.prototype, 'toDateOnly', {
    get: function (): string {
      return DateTime.fromJSDate(this).toFormat('yyyy-MM-dd');
    },
  });
}

if (!Object.prototype.hasOwnProperty.call(Date.prototype, 'toLocalISOString')) {
  Object.defineProperty(Date.prototype, 'toLocalISOString', {
    get: function (): string {
      return DateTime.fromJSDate(this).toFormat("yyyy-MM-dd'T'HH:mm:ss");
    },
  });
}

if (!Object.prototype.hasOwnProperty.call(Date.prototype, 'toUTCISOString')) {
  Object.defineProperty(Date.prototype, 'toUTCISOString', {
    get: function (): string {
      return DateTime.fromJSDate(this)
        .toUTC()
        .toFormat("yyyy-MM-dd'T'HH:mm:ss");
    },
  });
}

export {};
